<template>
  <div class="DataTables SearchedDetailsPriceTableComponent">

    <p>{{lang.infotext_1}}:</p>

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"


    import $ from 'jquery';
    import dt from 'datatables.net-bs4';
    //import { mapGetters } from 'vuex'


    export default {
        name: "SearchedDetailsPriceTableComponent",
        props:{
          lang: Object
        },
        components: {

          LoaderComponent
        },
        data () {
            return {
                id: "tableplace_"+this._uid,
                columns: [],
                colsAssign: [],
                mainTable: "",
                searchedDetails: [],
                prices: [],

            }
        },
        computed: {
          distributorPartId(){

            return this.$store.getters.selectedSearchedRows.DistributorPartId;

          },

          isData(){

            return this.distributorPartId != undefined;

          },

        },
        created () {

          let vue = this;

          let obj ={
            distributorPartId: this.distributorPartId
          }

          let payload = this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSearchedPartsDetails", obj)
          .then(function(result) {
            console.log("_getSearchedPartsDetails")
            console.log(result.data)

            if (result.status == "OK"){
              vue.prices = result.data.Prices


              vue.buildColumns();
            }

          })

        },
        watch: {
          distributorPartId: function (newVal, oldVal) {
            console.log("watch _getSearchedPartsDetails")

            let vue = this;

            let obj ={
              distributorPartId: newVal
            }

            let payload = this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSearchedPartsDetails", obj)
            .then(function(result) {
              console.log("_getSearchedPartsDetails")
              console.log(result.data)

              if (result.status == "OK"){
                vue.prices = result.data.Prices


                vue.buildColumns();
              }



            })

          }
        },
        updated() {

        },
        mounted: function () {

        },
        methods: {

          buildColumns(){

            this.colsAssign =  [

              { "data": "MinQuantity" },
              { "data": "Price" },
              { "data": "Currency" },

            ]

            this.columns = [

              {
                name: this.lang.table_header_MinQuantity,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Price,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Currency,
                alignInColumn: "left",

              },

            ]



            this.buildData();
          },

          buildData(){

            this.searchedDetails = [];



            for (let i = 0, lei = this.prices.length; i < lei; i++){
              let row = {
                MinQuantity: this.prices[i].MinQuantity,
                Price: this.prices[i].Price,
                Currency: this.prices[i].Currency,
              };
              this.searchedDetails.push(row);

            }


            this.buildTable();
          },

          buildTable(){
            console.log("buildTablesearcheddetails")

            var tableplace = document.getElementById(this.id);
            if (tableplace == null){
              return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_"+this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            table.setAttribute("style", "width:100%;");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");
            tr.setAttribute("class", "cellHeader");
            var thead = document.createElement("thead");
            thead.appendChild(tr);
            table.appendChild(thead);

            var _vue = this;




            var columnDefs = [];

            for (let i = 0, len = this.columns.length; i < len; i++){

              let classname = '_dt-body-'+ this.columns[i].alignInColumn;

              let  el = {
                  targets: i,
                  className: classname,
                  render: function ( data, type, row, meta ) {
                    if (data == null) {
                      data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                      data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                    if (meta.col == 0){
                      return data;
                    }
                    if (meta.col == 1){
                      if (row.type == "image"){


                        return "<img src=\"" + data + "\" class=\"img-thumbnail img-fluid\">";

                      }else{
                        return data;
                      }

                    }
                    return data;
                  }
                }

                columnDefs.push(el);


              var th = document.createElement("th");
              tr.appendChild(th);
              var br = document.createElement("br");
              th.appendChild(br);

              var tx = document.createTextNode(this.columns[i].name)
              th.appendChild(tx);

            }


            var option = {};
            option.paging = false;
            option.info = false;
            option.dom = 'f<t>';
            option.order = [0, "asc"];
            option.data= this.searchedDetails;
            option.myColumnFormats = this.columns;
            option.select = false;
            option.columns = this.colsAssign;
            option.columnDefs = columnDefs;

            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();
                console.log("DESTROY TABLE")
            }



            this.mainTable = $('#t_'+this.id).DataTable(option);


            this.mainTable.columns.adjust().draw();

            //hide first column in table
            //this.mainTable.column( 0 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          },

        }

    }
</script>
<style lang="scss">
  .SearchedDetailsPriceTableComponent{
    table{
      font-size: 0.75rem;
      padding: 0px !important;

    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .img-thumbnail{
      max-width: 300px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/SearchedDetailsPriceTableComponent.vue